export function mapTailwindWidthToPercent(string?: string) {
  if (!string || string === 'w-full')
    return '100%'

  const [dividend, divisor] = string.replace('w-', '').split('/')

  return `${(+dividend / +divisor) * 100}%`
}
